import {CodeResponseBody, CodelistResponseBody} from '../types';

export const codes: CodeResponseBody[] = [
  {
    codeId: '1',
    name: 'Test1',
    priority: 1,
    isDisabled: false,
  },
  {
    codeId: '2',
    name: 'Test2',
    priority: 2,
    isDisabled: true,
  },
];

export const codelistResponseMock: CodelistResponseBody = {
  codelistId: 'Test',
  name: 'testName',
  codes,
};
